;(function () {
  var nav = document.querySelector('.foundry--nav')
  if (nav) {
    var toggle = nav.querySelector('.nav--toggle')
    toggle.addEventListener('click', function (e) {
      toggle.classList.toggle('active')
    })
    var mainNavEntries = nav.querySelectorAll('.main--nav .nav--group')
    mainNavEntries.forEach(function (group) {
      var link = group.querySelector('.nav--link')
      if (link) {
        link.addEventListener('click', function (e) {
          group.classList.toggle('active')
        })
      }
    })
  }
})()
